export default __webpack_public_path__ + "static/media/Single-Point Stab.e8978ed1.png";